import React from 'react';
import { Container, Paper, Tabs, Tab, Box } from '@mui/material';
import { useState } from 'react';
import WorkingHours from './WorkingHours';
import VacationDays from './VacationDays';

const ScheduleManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Paper className="schedule-container">
      <Tabs 
        value={activeTab} 
        onChange={(_, newValue) => setActiveTab(newValue)}
      >
        <Tab label="Working Hours" />
        <Tab label="Vacation Days" />
      </Tabs>

      {activeTab === 0 && (
        <Paper className="schedule-content">
          <WorkingHours />
        </Paper>
      )}
      {activeTab === 1 && (
        <Paper className="schedule-content">
          <VacationDays />
        </Paper>
      )}
    </Paper>
  );
};

export default ScheduleManagement; 